import styled from 'styled-components';

export const Title = styled.div`
  font-size: 24px;
  font-weight: 600a;
`;

export const ModalWrapper = styled.div`
  button {
    width: 164px;
  }
`;
